export default __webpack_public_path__ + "static/media/HOWLEYHALL__2020_COVER.ab752f56.jpg";